import CardPicker from '../../CardPicker/CardPicker';

import PairedNewCard from './PairedNewCard';
import ElavonManualEntry from './ElavonManualEntry';

const CardEntryContent = ({
  cards,
  processor,
  patientId,
  selectedCardId,
  isNew,
  newMethodKey,
  onSelectCard,
  onUseAnotherCard,
  scrollRef,
  isFetchingNextPage
}) => {
  if (isNew)
    return processor === 'elavon' ? (
      <ElavonManualEntry patientId={patientId} method={newMethodKey} />
    ) : (
      <PairedNewCard hideButton />
    );

  return (
    <div className="flex w-full flex-col gap-5">
      <CardPicker
        cards={cards}
        selectedCardId={selectedCardId}
        onSelectCard={onSelectCard}
        onUseAnotherCard={onUseAnotherCard}
        scrollRef={scrollRef}
        isScrollable
        isFetchingNextPage={isFetchingNextPage}
      />
    </div>
  );
};

export default CardEntryContent;
